import { IconButton, Menu, MenuDotsIcon, MenuList } from '@lokalise/louis'
import type { PropsWithChildren } from 'react'
import styles from './EditMenu.module.css'

/**
 * Thin, styled wrapper over louis Menu component
 */
export const EditMenu = ({ children }: PropsWithChildren) => (
  <Menu
    menuButton={({ opened }) => (
      <IconButton active={opened} ariaLabel="Profile actions">
        <MenuDotsIcon />
      </IconButton>
    )}
  >
    <MenuList className={styles.menu} placement="bottom-end">
      {children}
    </MenuList>
  </Menu>
)
